export const createProdutoModel = ({
  id_produto = '',
  numero = '',
  produto = '',
  id_unidade = '',
  unidade = '',
  preco_venda = 0,
  qtde_estoque = 0,
  unidade_saida
} = {}) => ({
  id_produto,
  numero,
  descricao: produto,
  id_unidade,
  unidade,
  preco_bruto: preco_venda,
  qt_estoque: qtde_estoque,
  unidades_saida: unidade_saida
});